export const ALL_MCP_SERVERS = [
  'cloud',
  'comm',
  'content',
  'issue',
  'storage',
  'artrack',
  'business',
  'knowledge',
  'oneal',
  'oneal-storage',
  'ai',
  'tree',
  'codepilot',
  'review',
] as const;
